import { createGlobalStyle } from 'styled-components';
import reset from 'styled-reset';
import { font, thejamsilFont } from './font';

const GlobalStyles = createGlobalStyle`
/* css 리셋 */
  ${reset}
/* font */
  ${font}
  body {
    ${thejamsilFont('light')}
    
  }
  ::-webkit-scrollbar {
    display: none;
  }
  a{
      text-decoration: none;
      color:inherit;
  }
  button{
      border: none;
      background: none;
      padding: 0;
      outline: none;
      cursor: pointer;
      color: black;
  }
  select {
    margin: 0;
    border: none;
    padding: 0;
    font-size: 1rem;
    vertical-align: middle;
    color: #000;
    outline: 0;
    -webkit-appearance:none; 
    -moz-appearance:none; 
    appearance:none;
  }
  input,
  select,
  textarea {
    border-radius: 0;
    -webkit-border-radius: 0;
    background-color: #fff;
  }
  img,
  input {
    vertical-align: top;
    border: none;
    outline: none;
  }
  body,
  div,
  span,
  applet,
  object,
  iframe,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  blockquote,
  pre,
  abbr,
  acronym,
  address,
  big,
  cite,
  code,
  del,
  dfn,
  em,
  font,
  img,
  ins,
  kbd,
  q,
  s,
  samp,
  small,
  strike,
  strong,
  sub,
  sup,
  tt,
  var,
  b,
  u,
  i,
  center,
  dl,
  dt,
  dd,
  ol,
  ul,
  li,
  fieldset,
  form,
  label,
  legend,
  table,
  caption,
  tbody,
  tfoot,
  thead,
  tr,
  th,
  td {
    vertical-align: baseline;
    background: transparent;
    -webkit-text-size-adjust: none;
    list-style: none;
    line-height: 1;
    -webkit-tap-highlight-color: transparent;
  }
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    transition: background-color 5000s ease-in-out 0s;
    -webkit-transition: background-color 9999s ease-out;
    -webkit-box-shadow: 0 0 0px 1000px white inset !important;
    -webkit-text-fill-color: #000 !important;
}

.blind {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  clip-path: inset(50%);
}

html {
  font-size: 16px;
}

@media only screen and (max-width: 359px) {
  html {
    font-size: 14.22222px;
  }
}

@media screen and (min-width: 740px) {
  /* PC CSS */
  html {
    width: 414px;
    margin: 0 auto;
  }
  body {
    background-color: #ececec;
  }
}
#root {
  background-color: white;
  min-height: 100vh;
}
`;

export default GlobalStyles;
